import type { SVGProps } from 'react';

/** Figma `pause-button.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const PauseButtonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 4.5C1.5 3.08579 1.5 2.37868 1.93934 1.93934C2.37868 1.5 3.08579 1.5 4.5 1.5C5.91421 1.5 6.62132 1.5 7.06066 1.93934C7.5 2.37868 7.5 3.08579 7.5 4.5V13.5C7.5 14.9142 7.5 15.6213 7.06066 16.0607C6.62132 16.5 5.91421 16.5 4.5 16.5C3.08579 16.5 2.37868 16.5 1.93934 16.0607C1.5 15.6213 1.5 14.9142 1.5 13.5V4.5Z"
      fill="currentColor"
    />
    <path
      d="M10.5 4.5C10.5 3.08579 10.5 2.37868 10.9393 1.93934C11.3787 1.5 12.0858 1.5 13.5 1.5C14.9142 1.5 15.6213 1.5 16.0607 1.93934C16.5 2.37868 16.5 3.08579 16.5 4.5V13.5C16.5 14.9142 16.5 15.6213 16.0607 16.0607C15.6213 16.5 14.9142 16.5 13.5 16.5C12.0858 16.5 11.3787 16.5 10.9393 16.0607C10.5 15.6213 10.5 14.9142 10.5 13.5V4.5Z"
      fill="currentColor"
    />
  </svg>
);
